import { Grid, TextField, FormHelperText, Box } from "@mui/material";
import React, { useEffect } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import loginIcon from "../../assets/authentication-imgs/main-logo.svg";
import errorIcon from "../../assets/authentication-imgs/error-icon.svg";
import "./signin.scss";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link, useNavigate } from "react-router-dom";
import AttempsRemaining from "./warnings-modals/attempsRemaining";
import IncorrectAttempts from "./warnings-modals/incorrectAttempts";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { loginFetch } from "./features/funtions";
import { setToken } from "../../constant/token";

const Signin: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [attemptsRemainingModal, setAttemptsRemainingModal] =
    React.useState<boolean>(false);
  const [incorrectAttemptsModal, setIncorrectAttempts] =
    React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<any>("");
  const [accountIsBlocked, setAccountBlock] = React.useState<boolean>(false);
  const [noOfAttempts, setNoOfAttempts] = React.useState<number>(1);

  const showPasswodHandler = () => {
    setShowPassword(!showPassword);
  };
  const initialSchema = {
    email: "",
    password: "",
    rememberMe: false,
  };
  const validate = Yup.object({
    email: Yup.string()
      .required("Email is required")
      .email("Enter a valid email"),
    password: Yup.string().required("Password is required"),
  });

  const SignInSubmitHandler = async (values: any) => {
    setNoOfAttempts(noOfAttempts + 1);
    // const signInFetch: any = await dispatch(loginFetch(values));
    const signInFetch = {
      payload: {
        token:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiYWRtaW4iOnRydWUsImlhdCI6MTUxNjIzOTAyMn0.KMUFsIDTnFmyG3nMiGM6H9FNFUROf3wh7SmqJp-QV30",
      },
    };

    if (signInFetch.payload) {
      navigate("/");
      setToken(signInFetch.payload.token);
    }
    if (!signInFetch.payload) {
      switch (noOfAttempts) {
        case 1:
          setErrorMessage(`Email or Password is incorrect`);
          break;
        case 2:
        case 3:
          setErrorMessage(
            `Sign in details are incorrect, please check and try again. Attempts Remaining: ${
              4 - noOfAttempts
            }`
          );
          setAttemptsRemainingModal(true);
          break;
        default:
          setErrorMessage(
            "Your account has been locked due to several incorrect attempts."
          );
          setIncorrectAttempts(true);
          setAccountBlock(true);
          return;
      }
    } else {
      // setErrorMessage(signInFetch.error.message);
    }
  };

  const { values, touched, errors, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialSchema,
      validationSchema: validate,
      onSubmit: SignInSubmitHandler,
    });

  // useEffect(() => {
  //   setTimeout(() => {
  //     setErrorMessage("");
  //   }, 9000);
  // });
  return (
    <div className="sign-in">
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={6} xl={7}>
          <div className="sign-in-main flex-center-center flex-column">
            <div>
              <img src={loginIcon} />
            </div>
            <div>
              <h2 className="sign-in-title fw-700 h1">Get Started!</h2>
            </div>

            <form className="form d-flex flex-column " onSubmit={handleSubmit}>
              {errorMessage && (
                <Grid item xs={12} textAlign="center">
                  <Box>
                    <FormHelperText error>{errorMessage}</FormHelperText>
                  </Box>
                </Grid>
              )}
              <TextField
                sx={{
                  marginBottom: "3px",
                  backgroundColor: "white",
                  "&:hover .MuiOutlinedInput-root": {
                    "& > fieldset": {
                      borderColor: "#F78812",
                    },
                  },
                }}
                size="small"
                type="email"
                id="email"
                variant="outlined"
                placeholder="Email"
                error={!!(errors.email && touched.email)}
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.email && touched.email && (
                <span className="error-message">
                  <img src={errorIcon} />
                  <small>{errors.email}</small>
                </span>
              )}

              <FormControl
                className="root"
                size="small"
                sx={{
                  "&:hover .MuiOutlinedInput-root": {
                    "& > fieldset": {
                      borderColor: "#F78812",
                    },
                  },
                  marginTop: "30px",
                  marginBottom: "3px",
                  backgroundColor: "white",
                }}
              >
                <OutlinedInput
                  fullWidth
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                  value={values.password}
                  onChange={handleChange}
                  id="password"
                  onBlur={handleBlur}
                  error={!!(errors.password && touched.password)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOff onClick={showPasswodHandler} />
                        ) : (
                          <Visibility onClick={showPasswodHandler} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {errors.password && touched.password && (
                <span className="error-message">
                  <img src={errorIcon} />
                  <small>{errors.password}</small>
                </span>
              )}

              <div className="checkbox-div flex-center-between ">
                <div className="checkbox d-flex">
                  <input
                    type="checkbox"
                    className="input-checkbox table-checkbox"
                    id="rememberMe"
                    onChange={handleChange}
                  />
                  <span className="fw-500"> Remember me</span>
                </div>
                <div className="forgot-text">
                  <Link to="/forgot-password">
                    <p className="fw-500 cursor-pointer">
                      Forgot your password ?
                    </p>
                  </Link>
                </div>
              </div>
              <button
                className="btn btn-primary btn-sm submit-btn"
                style={{ cursor: accountIsBlocked ? "notAllowed" : "pointer" }}
                type="submit"
                disabled={accountIsBlocked}
              >
                Sign in
              </button>
              {/* <Button onClick={() => setAttemptsRemainingModal(true)}>
                Remining attempts
              </Button>
              <Button onClick={() => setIncorrectAttempts(true)}>
                incorrect attemps
              </Button> */}
            </form>

            <div className="footer-text">
              <p className="fw-500">
                <span className="content">Don't have an account? &nbsp;</span>
                <Link to="/signup">
                  <span className="signUp-text">sign up</span>
                </Link>
              </p>
            </div>
          </div>
        </Grid>

        <AttempsRemaining
          setOpenModal={setAttemptsRemainingModal}
          openModal={attemptsRemainingModal}
          noOfAttempts={noOfAttempts}
        />
        <IncorrectAttempts
          setOpenModal={setIncorrectAttempts}
          openModal={incorrectAttemptsModal}
        />

        <Grid
          item
          sm={5}
          md={6}
          lg={6}
          xl={5}
          sx={{ display: { xs: "none", md: "block" } }}
        >
          <div className="loginBg"></div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Signin;
